export default function getWebviewType() {
  return window.isCheckout ? 'checkout' : 'merchant';
}
